export const environment = {
  production: true,
  splixerUrl: 'https://api.splixer.com/player_api/v2/',
  defaultStationCode: "f3f715e8-76f8-4136-8ca4-c3d4ec2c4d08",
  defaultGaTrackingId: '',
  debugMode: false,
  showDebugInfo: true
};
